import { render } from "./RelatedDocumentsSection.vue?vue&type=template&id=0ad49e7e&scoped=true&ts=true&lang=pug"
import script from "./RelatedDocumentsSection.vue?vue&type=script&lang=ts"
export * from "./RelatedDocumentsSection.vue?vue&type=script&lang=ts"

import "./RelatedDocumentsSection.vue?vue&type=style&index=0&id=0ad49e7e&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad49e7e"]])

export default __exports__